export function updateBrowserURL(formSearch, additionalTag = "") {
    if (formSearch) {
        const formData = new FormData(formSearch)
    
        const fieldsToDelete = ["resultTargetPage", "currentUrl", "modelId"];
        fieldsToDelete.forEach(name => formData.delete(name))

        if (additionalTag.length > 0) {
            formData.set('tagSelection', additionalTag);
        }    
    
        const params = getUniqueParams(new URLSearchParams(formData)).toString();

        history.pushState(null, '', `?${params}`);
    } 
}

export function getUniqueParams(originalParamList) {
    const paramsMap = new Map();

    for(const [param, value] of originalParamList) {
        if (!paramsMap.has(param)) {
            paramsMap.set(param, new Set([value]))
        } else {
            paramsMap.get(param).add(value)
        }
    }

    const distinctParams = new URLSearchParams();

    paramsMap.forEach((values, param) => {
        values.forEach(value => distinctParams.append(param, value));
    });

    return distinctParams;
}